import React, { Component } from "react";
import Path2 from "../../assets/bookingeventassets/assets/path2.svg";
import { THANK_YOU_REDIRECT_DELAY_MS } from "../../utils/bookingRedirect";

class BookingStepRedirect extends Component {
  componentDidMount() {
    const { redirectUrl } = this.props;
    if (redirectUrl) {
      this.redirectTimer = setTimeout(() => {
        window.location.href = redirectUrl;
      }, THANK_YOU_REDIRECT_DELAY_MS);
    }
  }

  componentWillUnmount() {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
  }

  render() {
    return (
      <div className="row justify-content-center sub_div confirm-book">
        <div className="col-12 main_add border-0">
          <div className="col-12 text-center mb-2">
            <img src={Path2} alt="booking icon" className="book_icon" />
          </div>
          <div className="col-12 mb-2">
            <h1 id="sub_head" className="text-center">
              Redirecting
            </h1>
          </div>
          <div className="col-12 mb-4 text-center">
            <p>You will be redirected shortly...</p>
          </div>
          <div className="col-12 text-center">
            <div
              className="spinner-border text-warning"
              role="status"
              style={{ width: "2.5rem", height: "2.5rem" }}
            >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BookingStepRedirect;
